import { IconTrophy } from '@tabler/icons-react';
import styled from 'styled-components';

import Text from '@Components/atoms/Text';

interface RootProps {
  readonly isHighlighted: boolean;
}

export const Root = styled.div<RootProps>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(props) => props.theme.space.xs_4};
  padding: ${(props) => props.theme.space.xs_4} 0.5rem;
  border-radius: 6px;
  background-color: ${(props) => (props.isHighlighted ? props.theme.palette.table.row.highlight : null)};

  transition:
    border ${(props) => props.theme.transition.theme},
    background-color ${(props) => props.theme.transition.theme};
`;

export const SkeletonTooltipTrigger = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(props) => props.theme.space.xs_4};
  width: 100%;
  min-width: 0;
`;

export const PositionText = styled(Text)`
  min-width: 2.5rem;
  text-align: center;
`;

export const ScoreText = styled(Text)`
  min-width: 4.25rem;
`;

export const WordsPerMinuteText = styled(Text)`
  min-width: 2rem;
`;

export const CreatedAtText = styled(Text)`
  min-width: 2rem;
`;

export const StyledTrophyIcon = styled(IconTrophy)<{ rank: number }>`
  min-width: 2.5rem;

  stroke: ${(props) => {
    switch (props.rank) {
      case 1:
        return props.theme.palette.static.casualMatchPosition.first;
      case 2:
        return props.theme.palette.static.casualMatchPosition.second;
      case 3:
        return props.theme.palette.static.casualMatchPosition.third;
    }
  }};
`;
